module.exports = __webpack_public_path__ + "static/media/protective-shirt.1d0cd69c.jpg";